import React, { useState, useEffect } from "react";

import { Box, Card, Grid, Typography, Button, Input, Tooltip, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, Divider } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import DownloadIcon from '@mui/icons-material/Download';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import 'dayjs/plugin/customParseFormat';
import GlobalConfig from "../../../config/date/GlobalConfig";
import * as XLSX from "xlsx";
import CallAlertBar from '../../../Layout/Alertbar';
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import ImportQCSpecData from "./ImportQCSpecData";
import { Upload } from "@mui/icons-material";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const QCDataCollection = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [qcdata, setQcdata] = useState([]);

    const [qcupload, setQcupload] = useState(false);
    const [qcDetailsView, setqcDetailsView] = useState(true);
    const [qcSpecUpload, setQcSpecUpload] = useState(false);
    const [qcExistingdata, setQcExistingdata] = useState([]);

    const columnsExisting = [
        { field: 'date', headerName: 'PRODUCTION DATE', width: 150 },
        { field: 'jumbono', headerName: 'JUMBO NO', width: 120 },
        { field: 'quality', headerName: 'QUALITY', width: 120 },
        { field: 'ordergsm', headerName: 'ORDER GSM', width: 120 },
        { field: 'avggsm', headerName: 'AVG GSM', width: 120 },
        { field: 'calipermicron', headerName: 'CALIPER (micron)', width: 150 },
        { field: 'bulkccpergm', headerName: 'BULK (cc/gm)', width: 140 },
        { field: 'stiffnessmd', headerName: 'STIFFNESS MD (mN)', width: 160 },
        { field: 'stiffnesscd', headerName: 'STIFFNESS CD (mN)', width: 160 },
        { field: 'stiffnessgm', headerName: 'STIFFNESS GM (mN)', width: 160 },
        { field: 'ratio', headerName: 'RATIO', width: 100 },
        { field: 'cobbtop', headerName: 'COBB TOP', width: 120 },
        { field: 'cobbback', headerName: 'COBB BACK', width: 120 },
        { field: 'plybond', headerName: 'PLYBOND (J/m2)', width: 150 },
        { field: 'igtdrypick', headerName: 'IGT DRY PICK (m/sec)', width: 170 },
        { field: 'roughnesspps', headerName: 'ROUGHNESS PPS (um)', width: 170 },
        { field: 'gloss', headerName: 'GLOSS (%)', width: 120 },
        { field: 'moisture', headerName: 'MOISTURE (%)', width: 130 },
        { field: 'brightness', headerName: 'BRIGHTNESS (%)', width: 150 },
        { field: 'backbrightness', headerName: 'BACK BRIGHTNESS (%)', width: 180 },
    ];

    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        {
            field: 'Date', headerName: 'Date', width: 130,
            valueFormatter: (params) => {
                const date = params.value;
                return date ? (typeof date === 'object' ? date.toLocaleDateString() : date) : '';
            }
        },
        { field: 'Jumbo No', headerName: 'Jumbo No', width: 130 },
        { field: 'Quality', headerName: 'Quality', width: 130 },
        { field: 'Order GSM', headerName: 'Order GSM', width: 110 },
        { field: 'Avg GSM', headerName: 'Avg GSM', width: 110 },
        { field: 'Caliper (micron)', headerName: 'Caliper (micron)', width: 150 },
        { field: 'Bulk (cc/gm)', headerName: 'Bulk (cc/gm)', width: 130 },
        { field: 'Stiffness MD (mN)', headerName: 'Stiffness MD (mN)', width: 150 },
        { field: 'Stiffness CD (mN)', headerName: 'Stiffness CD (mN)', width: 150 },
        { field: 'Stiffness GM (mN)', headerName: 'Stiffness GM (mN)', width: 150 },
        { field: 'Ratio', headerName: 'Ratio', width: 100 },
        { field: 'Cobb Top', headerName: 'Cobb Top', width: 120 },
        { field: 'Cobb Back', headerName: 'Cobb Back', width: 120 },
        { field: 'Plybond (J/m2)', headerName: 'Plybond (J/m2)', width: 150 },
        { field: 'IGT Dry pick (m/sec)', headerName: 'IGT Dry pick (m/sec)', width: 180 },
        { field: 'Roughness PPS  (um)', headerName: 'Roughness PPS (um)', width: 180 },
        { field: 'Gloss (%)', headerName: 'Gloss (%)', width: 120 },
        { field: 'Moisture (%)', headerName: 'Moisture (%)', width: 120 },
        { field: 'Brightness(%)', headerName: 'Brightness (%)', width: 130 },
        { field: 'BackBrightness(%)', headerName: 'Back Brightness (%)', width: 150 },
    ];

    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });
    const filteredData = qcdata.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const filteredDataExisting = qcExistingdata.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });
    const rows = filteredDataExisting.map((row, index) => ({
        id: row.id ?? index + 1,
        ...row,
    }));



    // const handleFileChange = (event) => {
    //     const file = event.target.files[0];

    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             const data = new Uint8Array(e.target.result);

    //             // Specify the cellDates option to handle date formatting
    //             const workbook = XLSX.read(data, { type: 'array', cellDates: true });

    //             // Assuming 'StockData' is the first sheet in the Excel file
    //             const sheetName = workbook.SheetNames[0];
    //             const sheet = workbook.Sheets[sheetName];

    //             // Convert sheet data to JSON
    //             const jsonData = XLSX.utils.sheet_to_json(sheet);

    //             // Define expected columns
    //             const expectedColumns = [
    //                 'Date',
    //                 'Jumbo No',
    //                 'Quality',
    //                 'Order GSM',
    //                 'Avg GSM',
    //                 'Caliper (micron)',
    //                 'Bulk (cc/gm)',
    //                 'Stiffness MD (mN)',
    //                 'Stiffness CD (mN)',
    //                 'Stiffness GM (mN)',
    //                 'Ratio',
    //                 'Cobb Top',
    //                 'Cobb Back',
    //                 'Plybond (J/m2)',
    //                 'IGT Dry pick (m/sec)',
    //                 'Roughness PPS  (um)',
    //                 'Gloss (%)',
    //                 'Moisture (%)',
    //                 'Brightness(%)',
    //                 'BackBrightness(%)'
    //             ];

    //             // Add incremental IDs to each row and validate each field
    //             const dataWithIds = jsonData.map((row, index) => {
    //                 // Log the current row for debugging
    //                 console.log(`Row ${index + 1}:`, row);

    //                 // Check for missing or empty fields in expected columns
    //                 const hasEmptyField = expectedColumns.some(col => {
    //                     const value = row[col];
    //                     // Log the value being checked
    //                     console.log(`Checking column "${col}":`, value);

    //                     return value === undefined || value === null || value === '';
    //                 });

    //                 const isValid = !hasEmptyField; // true if no empty fields, false otherwise

    //                 // Log the validation result for the current row
    //                 console.log(`Row ${index + 1} isValid:`, isValid);

    //                 return {
    //                     id: index + 1,
    //                     ...row,
    //                     isValid: isValid // true if no empty fields, false otherwise
    //                 };
    //             });



    //             // Set the data to state
    //             setQcdata(dataWithIds);
    //         };

    //         reader.readAsArrayBuffer(file);
    //     }
    // };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array', cellDates: true });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            const expectedColumns = [
                'Date', 'Jumbo No', 'Quality', 'Order GSM', 'Avg GSM',
                'Caliper (micron)', 'Bulk (cc/gm)', 'Stiffness MD (mN)',
                'Stiffness CD (mN)', 'Stiffness GM (mN)', 'Ratio', 'Cobb Top',
                'Cobb Back', 'Plybond (J/m2)', 'IGT Dry pick (m/sec)',
                'Roughness PPS  (um)', 'Gloss (%)', 'Moisture (%)',
                'Brightness(%)', 'BackBrightness(%)'
            ];

            const dataWithIds = jsonData.map((row, index) => {
                const normalizedRow = Object.keys(row).reduce((acc, key) => {
                    acc[key.trim()] = row[key];
                    return acc;
                }, {});

                const hasEmptyField = expectedColumns.some(col => {
                    const value = normalizedRow[col];
                    return value === undefined || value === null || value === '';
                });

                return {
                    id: index + 1,
                    ...normalizedRow,
                    isValid: !hasEmptyField
                };
            });

            setQcdata(dataWithIds);
        };

        reader.readAsArrayBuffer(file);
    };


    const downloadExcelFile = () => {
        const excelFilePath = '/excel-templates/QCDataTemplate.xlsx';
        const link = document.createElement('a');
        link.href = excelFilePath;
        link.download = 'QCDataTemplate.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const callApiForSaveQCDetails = async (requestBody) => {
        try {
            const response = await fetch(API_ENDPOINTS.PRODUCTION_SAVE_QC_DATA, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                throw new Error('Unable to update QC data');
            }
            const data = await response.json();
            if (data === 'Quality certificate data successfully imported.') {
                msg('info', 'Info', data);

                setQcdata([]);
            }
            else {
                msg('error', 'Error', data);


            }


        } catch (error) {
            msg('error', 'Error', 'Unable to update QC data');
            throw error; // rethrow the error so that the calling function can handle it
        }
    };



    // Function to prepare data for the API
    // const prepareDataForAPI = () => {
    //     return qcdata
    //         .filter(row => selectedRows.includes(row.id)) // Only include selected rows
    //         .map(row => ({
    //             Date: row.Date instanceof Date
    //                 ? row.Date.toISOString().slice(0, 10) // Convert to "YYYY-MM-DD"
    //                 : new Date(row.Date).toISOString().slice(0, 10), // Ensure Date object and format
    //             JumboNo: row["Jumbo No"],
    //             Quality: row.Quality,
    //             OrderGSM: row["Order GSM"],
    //             AvgGSM: row["Avg GSM"],
    //             CaliperMicron: row["Caliper (micron)"],
    //             BulkCcPerGm: row["Bulk (cc/gm)"],
    //             StiffnessMD: row["Stiffness MD (mN)"],
    //             StiffnessCD: row["Stiffness CD (mN)"],
    //             StiffnessGM: row["Stiffness GM (mN)"],
    //             Ratio: row["Ratio"],
    //             CobbTop: row["Cobb Top"],
    //             CobbBack: row["Cobb Back"],
    //             Plybond: row["Plybond (J/m2)"],
    //             IGTDryPick: row["IGT Dry pick (m/sec)"],
    //             RoughnessPPS: row["Roughness PPS  (um)"],
    //             Gloss: row["Gloss (%)"],
    //             Moisture: row["Moisture (%)"],
    //             Brightness: row["Brightness(%)"],
    //             BackBrightness: row["BackBrightness(%)"],

    //         }));
    // };

    // const prepareDataForAPI = () => {
    //     return qcdata
    //         .filter(row => selectedRows.includes(row.id) && row.isValid) // Include only valid & selected rows
    //         .map(row => {
    //             // Normalize date safely
    //             let formattedDate = null;
    //             if (row.Date instanceof Date) {
    //                 formattedDate = row.Date.toISOString().slice(0, 10);
    //             } else if (typeof row.Date === "string" && !isNaN(Date.parse(row.Date))) {
    //                 formattedDate = new Date(row.Date).toISOString().slice(0, 10);
    //             } else {
    //                 formattedDate = null; // Invalid or missing date
    //             }

    //             return {
    //                 Date: formattedDate,
    //                 JumboNo: row["Jumbo No"] ?? "",
    //                 Quality: row["Quality"] ?? "",
    //                 OrderGSM: row["Order GSM"] ?? "",
    //                 AvgGSM: row["Avg GSM"] ?? "",
    //                 CaliperMicron: row["Caliper (micron)"] ?? "",
    //                 BulkCcPerGm: row["Bulk (cc/gm)"] ?? "",
    //                 StiffnessMD: row["Stiffness MD (mN)"] ?? "",
    //                 StiffnessCD: row["Stiffness CD (mN)"] ?? "",
    //                 StiffnessGM: row["Stiffness GM (mN)"] ?? "",
    //                 Ratio: row["Ratio"] ?? "",
    //                 CobbTop: row["Cobb Top"] ?? "",
    //                 CobbBack: row["Cobb Back"] ?? "",
    //                 Plybond: row["Plybond (J/m2)"] ?? "",
    //                 IGTDryPick: row["IGT Dry pick (m/sec)"] ?? "",
    //                 RoughnessPPS: row["Roughness PPS  (um)"] ?? "",
    //                 Gloss: row["Gloss (%)"] ?? "",
    //                 Moisture: row["Moisture (%)"] ?? "",
    //                 Brightness: row["Brightness(%)"] ?? "",
    //                 BackBrightness: row["BackBrightness(%)"] ?? "",
    //             };
    //         });
    // };

    const prepareDataForAPI = () => {
        return qcdata
            .filter(row => selectedRows.includes(row.id) && row.isValid)
            .map(row => {
                let formattedDate = null;
                const dateValue = row.Date;

                // ✅ Handle multiple date formats safely
                if (dateValue instanceof Date) {
                    formattedDate = dateValue.toISOString().slice(0, 10);
                } else if (typeof dateValue === "string") {
                    // Check if format looks like "24.02.25"
                    const dotFormat = /^(\d{2})\.(\d{2})\.(\d{2})$/;
                    const dotFormatWithYear4 = /^(\d{2})\.(\d{2})\.(\d{4})$/;

                    if (dotFormat.test(dateValue)) {
                        const [, dd, mm, yy] = dateValue.match(dotFormat);
                        const fullYear = parseInt(yy, 10) + 2000; // assume 20xx
                        formattedDate = new Date(fullYear, mm - 1, dd).toISOString().slice(0, 10);
                    } else if (dotFormatWithYear4.test(dateValue)) {
                        const [, dd, mm, yyyy] = dateValue.match(dotFormatWithYear4);
                        formattedDate = new Date(yyyy, mm - 1, dd).toISOString().slice(0, 10);
                    } else if (!isNaN(Date.parse(dateValue))) {
                        formattedDate = new Date(dateValue).toISOString().slice(0, 10);
                    } else {
                        console.warn("Unrecognized date format:", dateValue);
                        formattedDate = null;
                    }
                }

                return {
                    Date: formattedDate,
                    JumboNo: row["Jumbo No"] ?? "",
                    Quality: row["Quality"] ?? "",
                    OrderGSM: row["Order GSM"] ?? "",
                    AvgGSM: row["Avg GSM"] ?? "",
                    CaliperMicron: row["Caliper (micron)"] ?? "",
                    BulkCcPerGm: row["Bulk (cc/gm)"] ?? "",
                    StiffnessMD: row["Stiffness MD (mN)"] ?? "",
                    StiffnessCD: row["Stiffness CD (mN)"] ?? "",
                    StiffnessGM: row["Stiffness GM (mN)"] ?? "",
                    Ratio: row["Ratio"] ?? "",
                    CobbTop: row["Cobb Top"] ?? "",
                    CobbBack: row["Cobb Back"] ?? "",
                    Plybond: row["Plybond (J/m2)"] ?? "",
                    IGTDryPick: row["IGT Dry pick (m/sec)"] ?? "",
                    RoughnessPPS: row["Roughness PPS  (um)"] ?? "",
                    Gloss: row["Gloss (%)"] ?? "",
                    Moisture: row["Moisture (%)"] ?? "",
                    Brightness: row["Brightness(%)"] ?? "",
                    BackBrightness: row["BackBrightness(%)"] ?? "",
                };
            });
    };





    async function SaveQCDetails() {
        const formattedData = prepareDataForAPI();

        if (formattedData.length === 0) {
            // If no valid rows, handle the case (e.g., show a message to the user)


            msg('warning', 'Warning', 'Altease select one valid QC data to import..!');
            return;
        }

        const requestBody = {
            obj: formattedData,
            p_companyid: 1,
            p_plantid: 1,
        };

        await callApiForSaveQCDetails(requestBody);
    }





    // State to track selected rows
    const [selectedRows, setSelectedRows] = useState([]);

    // Handle Select All Click
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Select all valid rows
            const allValidRowIds = filteredData.filter(row => row.isValid).map(row => row.id);
            setSelectedRows(allValidRowIds);
        } else {
            // Deselect all rows
            setSelectedRows([]);
        }
    };

    // Handle Individual Row Selection
    const handleRowCheckboxClick = (event, id) => {
        const selectedIndex = selectedRows.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }

        setSelectedRows(newSelected);
    };

    // Check if a row is selected
    const isSelected = (id) => selectedRows.indexOf(id) !== -1;

    const [deckleMatchingMsgOpen, setDeckleMatchingMsgOpen] = useState(false);
    const [deckleMatchingSeverityvalue, setDeckleMatchingSeverityvalue] = useState('info');
    const [deckleMatchingMessageValue, setDeckleMatchingMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [deckleMatchingAlertTitleValue, setDeckleMatchingAlertTitleValue] = useState('');

    const msg = (severityvalue, title, messageValue) => {
        setDeckleMatchingSeverityvalue(severityvalue);
        setDeckleMatchingMessageValue(messageValue);
        setDeckleMatchingAlertTitleValue(title);
        setDeckleMatchingMsgOpen(true);
    };


    const getAllQualityCertificateDetails = () => {
        let parameters = {
            p_companyid: 1,

        };

        callApi(API_ENDPOINTS.PRODUCTION_GetALLQualityCertificateDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                const formattedData = data.map(item => ({
                    ...item,
                    date: new Date(item.date).toISOString().split('T')[0] // Extracts the date as 'YYYY-MM-DD'
                }));
                setQcExistingdata(formattedData);


            })
            .catch(error => {
                // // Update state with error message        
                // setReelWeightementSeverityvalue('error');
                // setReelWeightementMessageValue(error.message);
                // setReelWeightementAlertTitleValue('Error');
                // setReelWeightementMsgOpen(true);
            });

    };

    const handleViewQCUpload = () => {
        setQcupload(true);
        setqcDetailsView(false);
        setQcSpecUpload(false);
    }

    const handleViewQCDetailsView = () => {
        setQcupload(false);
        setqcDetailsView(true);
        setQcSpecUpload(false);
    }

    const handleViewQCSpecUpload = () => {
        setQcupload(false);
        setqcDetailsView(false);
        setQcSpecUpload(true);
    }

    useEffect(() => {
        if (qcExistingdata) {
            getAllQualityCertificateDetails();
        }

    }, [qcExistingdata]);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
    });

    return (
        <>
            {qcDetailsView && (
                <Box style={{ backgroundColor: "transparent" }}>
                    <Box flexDirection={'row'} p={'5px'}>
                        <ReportsHeader title={'Quality Certificate Details'} subtitle="" callback={handleBackWinderMachineEntry} />
                    </Box>
                    <CardContent sx={{ border: "1px solid #3d3d3d" }}>
                        <Box display="flex" flexDirection={'column'}>
                            <Box display="flex" justifyContent={'flex-start'}>
                                <Grid container spacing={1} justifyContent="flex-start" style={{ marginBottom: '5px' }}>
                                    <Grid item>
                                        <Box display="flex" flexDirection={'row'}>
                                            {/* <Tooltip title="Import QC Data in Excel" >
                                                <IconButton style={{ borderRadius: '8px', }} onClick={handleViewQCUpload}>
                                                    <DownloadIcon style={{ marginRight: '5px', color: '#609ed4ff' }} />
                                                    <Typography variant="button" textTransform={'none'} fontSize={13} > Import QC Data</Typography>
                                                </IconButton>
                                            </Tooltip>

                                             <Tooltip title="Import QC Specification Data in Excel" >
                                                <IconButton style={{ borderRadius: '8px', }} onClick={handleViewQCSpecUpload}>
                                                    <DownloadIcon style={{ marginRight: '5px', color: '#609ed4ff' }} />
                                                    <Typography variant="button" textTransform={'none'} fontSize={13} > Import QC Spec Data</Typography>
                                                </IconButton>
                                            </Tooltip> */}

                                            <Button variant="outlined" startIcon={<Upload />} size="small" sx={{ mr: 1 }} color="secondary" onClick={handleViewQCUpload}>
                                                Upload QC Data
                                            </Button>
                                            <Button variant="outlined" startIcon={<Upload />} size="small" color="secondary" onClick={handleViewQCSpecUpload}>
                                                Upload QC Spec Data
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>


                        <CustomTableContainer colors={colors}>
                            <Box sx={{ height: 500, width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columnsExisting}
                                    pageSize={10}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    getRowHeight={() => 35} // smaller row height
                                    disableRowSelectionOnClick

                                    rowHeight={30}
                                    slots={{ toolbar: GridToolbar }}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </Box>
                        </CustomTableContainer>


                    </CardContent>

                </Box>

            )}

            {qcupload && (
                <Box style={{ backgroundColor: "transparent" }}>
                    <Box flexDirection={'row'} p={'5px'}>
                        <ReportsHeader title={'Import Quality Certificate Details'} subtitle="" callback={handleViewQCDetailsView} />
                    </Box>

                    <CallAlertBar
                        parentRollMsgOpen={deckleMatchingMsgOpen}
                        setParentRollMsgOpen={setDeckleMatchingMsgOpen}
                        parentRollSeverityvalue={deckleMatchingSeverityvalue}
                        setParentRollSeverityvalue={setDeckleMatchingSeverityvalue}
                        parentRollAlertTitleValue={deckleMatchingAlertTitleValue}
                        setParentRollAlertTitleValue={setDeckleMatchingAlertTitleValue}
                        parentRollMessageValue={deckleMatchingMessageValue}
                        setParentRollMessageValue={setDeckleMatchingMessageValue}
                    />

                    <CardContent sx={{ border: "1px solid #3d3d3d" }}>
                        <Box display="flex" flexDirection={'column'}>

                            <Box m='0px' display="flex" justifyContent="flex-start" alignItems="center">
                                <Box display="flex" mr={1} >
                                    <FormControl fullWidth>
                                        <Input
                                            id="file-input"
                                            type="file"
                                            accept=".xlsx, .xls"
                                            onChange={handleFileChange}
                                            sx={{ display: 'none' }}
                                        />
                                        <label htmlFor="file-input" style={{ cursor: "pointer" }}>
                                            <Tooltip title="Select CO Mapping Excel File" component="span">
                                                <Box display="flex" alignItems="center">
                                                    <IconButton component="span"> {/* Set `component="span"` to make it work as part of the label */}
                                                        <FileUploadRoundedIcon style={{ color: "#1de9b6" }} />
                                                    </IconButton>
                                                    <Typography align="left" fontSize={13} style={{ cursor: "pointer" }}>
                                                        Select
                                                    </Typography>
                                                </Box>
                                            </Tooltip>
                                        </label>
                                    </FormControl>


                                    <FormControl fullWidth>
                                        <Tooltip title="Save QC Details" onClick={SaveQCDetails}>
                                            <Box display="flex" alignItems="center">
                                                <IconButton>
                                                    <SaveOutlinedIcon style={{ color: "#388e3c" }} />
                                                </IconButton>
                                                <Typography align="left" fontSize={13} style={{ cursor: "pointer" }}>Save</Typography>
                                            </Box>
                                        </Tooltip>
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <Tooltip title="QC Excel Template" onClick={downloadExcelFile}>
                                            <Box display="flex" alignItems="center">
                                                <IconButton>
                                                    <FileDownloadRoundedIcon style={{ color: "#c0ca33" }} />
                                                </IconButton>
                                                <Typography align="left" fontSize={13} style={{ cursor: "pointer" }}>Download</Typography>
                                            </Box>
                                        </Tooltip>
                                    </FormControl>
                                </Box>


                            </Box>
                        </Box>

                        <Box textAlign="right" >
                            <Typography variant="subtitle1" gutterBottom>
                                * Invalid or missing data rows are highlighted in <span style={{ color: 'red' }}>red color</span>.
                            </Typography>
                        </Box>

                        <Divider sx={{ marginTop: '5px', marginBottom: '5px' }} />


                        <CustomTableContainer colors={colors}>

                            <Box display="flex" alignItems="center" mb={1}>
                                <Checkbox
                                    // size="small"
                                    indeterminate={
                                        selectedRows.length > 0 &&
                                        selectedRows.length < filteredData.filter(r => r.isValid).length
                                    }
                                    checked={
                                        selectedRows.length === filteredData.filter(r => r.isValid).length &&
                                        selectedRows.length > 0
                                    }
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            const allValidIds = filteredData.filter(r => r.isValid).map(r => r.id);
                                            setSelectedRows(allValidIds);
                                        } else {
                                            setSelectedRows([]);
                                        }
                                    }}
                                />
                                <Typography variant="h6">Select All</Typography>
                            </Box>


                            <Box sx={{ height: 430, width: '100%' }}>
                                <DataGrid
                                    rows={filteredData.map(row => ({
                                        ...row,
                                        id: row.id,
                                    }))}
                                    columns={columns}
                                    checkboxSelection
                                    disableRowSelectionOnClick
                                    isRowSelectable={(params) => params.row.isValid}
                                    rowSelectionModel={selectedRows}
                                    onRowSelectionModelChange={(newSelection) => {
                                        const validSelections = newSelection.filter(id => {
                                            const row = filteredData.find(r => r.id === id);
                                            return row?.isValid;
                                        });
                                        setSelectedRows(validSelections);
                                    }}
                                    rowHeight={30}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sx={{
                                        '& .invalid-row': { bgcolor: '#993636ff', color: '#fff' },
                                    }}
                                />

                            </Box>


                        </CustomTableContainer>

                    </CardContent>

                </Box>
            )}

            {qcSpecUpload && (
                <ImportQCSpecData handleBackWinderMachineEntry={handleViewQCDetailsView} />
            )}


        </>
    )
};
export default QCDataCollection;